// eslint-disable-next-line no-unused-vars
import { configureStore, EnhancedStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import * as Sentry from '@sentry/react';

import rootReducer, { rootMiddleware } from './reducers';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

let store;

/**
 * Returns a singleton store instance
 * @returns {{store: EnhancedStore}}
 */
export default function configureAppStore() {
  if (!store) {
    store = configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(rootMiddleware),
      enhancers: [sentryReduxEnhancer],
    });

    if (process.env.NODE_ENV !== 'production' && module.hot) {
      module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
    }
    setupListeners(store.dispatch);
  }

  return { store };
}
